import { Modal, roundNumber } from "@xola/ui-kit";
import React from "react";
import { LineItemObject, LineItemType, Purchase, PurchaseItem } from "types";
import { api } from "../../api/api";
import { CollectBalanceModalContent } from "./CollectPurchaseBalanceModal";
import { CollectBalanceFormValues } from "./CollectPurchaseBalanceTypes";

interface AddFundsGiftModalProps {
    purchase: Purchase;
    item: PurchaseItem;
    isOpen: boolean;
    onClose: () => void;
}

export const AddFundsGiftModal = ({ purchase, item, isOpen, onClose }: AddFundsGiftModalProps) => {
    const handleFetchRequest = (purchase: Purchase, values: CollectBalanceFormValues) => {
        return getPayload(purchase, values, item);
    };

    return (
        <Modal size="huge" isOpen={isOpen} onClose={onClose}>
            <CollectBalanceModalContent
                isAddFundModal
                purchase={purchase}
                onFetchRequestData={handleFetchRequest}
                onSubmit={async (values) => addFunds(purchase, item, values)}
                onClose={onClose}
            />
        </Modal>
    );
};

const addFunds = async (purchase: Purchase, item: PurchaseItem, values: CollectBalanceFormValues) => {
    // should use single op addLineItemWithPayment, to ensure any rollbacks on failed payments are handled properly.
    const payload = getPayload(purchase, values, item);
    payload.ops[0].op = "addLineItemWithPayment";
    payload.ops[0].data.payment = values.payment;
    return api.patch<Purchase>(`/purchases/${purchase.id}`, payload);
};

const getPayload = (purchase: Purchase, values: CollectBalanceFormValues, item: PurchaseItem): any => {
    return {
        ops: [
            {
                path: `/items/${item.id}/lineItems`,
                op: "addLineItem",
                data: {
                    object: LineItemObject.DEFAULT,
                    type: LineItemType.ADJUSTMENT,
                    amount: roundNumber(purchase.currency, values.amount),
                    name: values.tag || "Funds added",
                    includeInAmount: true,
                },
            },
        ],
    };
};
